module.exports = __webpack_public_path__ + "img/brake-icon.803ed9e3.svg";